import React, { useContext } from "react";
import { AnalyticsContext } from '../AnalyticsContext';
export const Analytics = () => {
        const analytics = useContext(AnalyticsContext);
        analytics.page();
    return (<React.Fragment />);
}